__turbopack_context__.v({
  "button": "DropdownButton-module-scss-module__djwa6a__button",
});
